/* Dependencies */
import styled from 'styled-components';

/* Components */
import { Grids, Optioner } from 'kinedu-react-components';

/* Icons */
import { ReactComponent as Back } from 'images/icons/arrowBackIos.svg';

export const StyledCenterView = styled.div.attrs(() => ({
  className: 'StyledCenterView',
}))`
  max-width: 960px;
  width: 95%;
  margin: 0 auto;
  overflow-x: hidden;
  padding: 36px 0 70px 0;

  ${({ theme }) => theme.breakPoints.desktop} {
    ${Grids.desktop}
    padding-top: 72px;
    min-height: 100%;
    padding: 36px 0 70px 0;

    &::after {
      content: '';
      width: 100vw;
      height: 100vh;
      position: absolute;
      left: 50%;
      top: 0;
      background: ${({ theme }) => theme.colors.lightGray};
      z-index: -1;
      transform: translateX(-50%);
    }

  }
`;

export const BackBtn = styled.button.attrs(() => ({
  className: 'CenterViewBackButton',
}))`
  display: none;

  ${({ theme }) => theme.breakPoints.desktop} {
    display: inline-block;

    display: flex;
    align-items: center;
    gap: 25px;

    background-color: transparent;
    border: none;
    margin-bottom: 10px;
    height: 40px;

    &:hover {
      cursor: pointer;
    }
  }
`;

export const BackBtnIcon = styled(Back).attrs(() => ({
  className: 'BackIcon',
}))`
  & svg {
    height: 16px;
    width: 11px;
  }

  & #fill {
    fill: ${({ theme }) => theme.colors.physical};
  }
`;

export const BackBtnLabel = styled.span.attrs(() => ({
  className: 'CenterViewBackButtonLabel',
}))`
  color: ${({ theme }) => theme.colors.physical};
  font-size: 16px;
  font-weight: bold;
`;

export const Row = styled.div.attrs(() => ({
  className: 'CenterViewRow',
}))`
  display: flex;
  flex-direction: column;
  grid-column: 2 / 14;
  grid-template-columns: repeat(11, 1fr);
  .breadcrumbs-container {
    padding: 20px 0;
    margin: 0;
  }
`;

export const Container = styled.div.attrs(() => ({
  className: 'CenterContainer',
}))`
  position: relative;
  grid-column: 2 / 14;
  flex: 1;

  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 2px 4px 0 #00000015;
  border-radius: 0 0 4px 4px;
  padding-bottom: 30px;

  & .Optioner-box::after {
    height: 2px;
  }

  ${({ theme }) => theme.breakPoints.desktop} {
    padding-bottom: 0;
  }
`;

export const Header = styled.div.attrs(() => ({
  className: 'CenterHeader',
}))`
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 40px;
  width: 100%;

  border-bottom: 1px solid #dde4ea;
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: 16px;
  font-weight: bold;
  padding: 16px 20px;

  ${({ theme }) => theme.breakPoints.tablet} {
    font-size: 18px;
    height: 64px;
    padding: 8px 16px;
  }
`;

export const Body = styled.div.attrs(() => ({ className: 'CenterBody' }))`
  ${({ theme }) => theme.breakPoints.tablet} {
    padding: 16px 32px;
  }
`;

export const StyledOptioner = styled(Optioner).attrs(() => ({
  className: 'CenterSettingsTabs',
}))`
  width: 100%;
  overflow-x: auto;

  .Optioner-checkbox-group {
    justify-content: flex-start;
    overflow-x: auto;
    box-shadow: inset -6px -1px 8px 0px rgba(0,0,0,0.1);
  }

  @media screen and (min-width: 480px) {
    .Optioner-checkbox-group {
      box-shadow: none;
    }
  }

  @media screen and (min-width: 600px) {
    width: max-content;
    & .Optioner-box {
      padding: 5px 20px;
    }
  }
`;
